// utils/fileValidation.ts (แนะนำให้แยกไฟล์ออก)
import { message, Upload } from "antd";

/**
 * ตรวจสอบขนาดไฟล์ให้น้อยกว่า maxSize (หน่วย MB)
 * @param {File} file - ไฟล์ที่ต้องการตรวจสอบ
 * @param {number} maxSize - ขนาดไฟล์สูงสุดที่อนุญาต (MB)
 * @returns {boolean} - คืนค่า false ถ้าไฟล์ผ่านการตรวจสอบ, Upload.LIST_IGNORE ถ้าไม่ผ่าน
 */
export const validateFileSize = (file: File, maxSize: number = 300) => {
  const isLtMaxSize = file.size / 1024 / 1024 < maxSize; // แปลงเป็น MB
  if (!isLtMaxSize) {
    message.error(`File must be smaller than ${maxSize}MB!`);
  }
  return isLtMaxSize ? false : Upload.LIST_IGNORE;
};
